import React, { useEffect, useState } from "react";
import { t } from "@/i18n";
import { fetchStats } from "@/api";

const StatsPanel = ({ lang }) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchStats().then(setStats).catch(() => setStats(null));
  }, []);

  if (!stats) return null;

  return (
    <div className="p-4 border border-white/10 rounded-md bg-black/40 space-y-3" data-testid="admin-stats">
      <div className="font-mono-display text-[10px] uppercase tracking-[0.25em] text-zinc-400">
        {t(lang, "stats")}
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="p-3 border border-white/10 rounded-md bg-black/60">
          <div className="font-mono-display text-[10px] uppercase tracking-widest text-zinc-500">
            {t(lang, "totalVisits")}
          </div>
          <div className="font-display text-3xl text-white mt-1" data-testid="stat-total-visits">
            {stats.total_visits}
          </div>
        </div>
        <div className="p-3 border border-white/10 rounded-md bg-black/60">
          <div className="font-mono-display text-[10px] uppercase tracking-widest text-zinc-500">
            {t(lang, "totalClicks")}
          </div>
          <div className="font-display text-3xl text-[#FF1493] mt-1" data-testid="stat-total-clicks">
            {stats.total_clicks}
          </div>
        </div>
      </div>
      {stats.per_link && stats.per_link.length > 0 && (
        <div>
          <div className="font-mono-display text-[10px] uppercase tracking-widest text-zinc-500 mb-2">
            {t(lang, "perLink")}
          </div>
          <div className="space-y-1">
            {stats.per_link.map((p) => {
              const max = Math.max(1, ...stats.per_link.map((x) => x.clicks));
              const pct = (p.clicks / max) * 100;
              return (
                <div key={p.id} className="flex items-center gap-2">
                  <div className="font-mono-display text-[11px] uppercase text-zinc-300 w-44 truncate">
                    {lang === "ru" ? p.label_ru : p.label_en}
                  </div>
                  <div className="flex-1 h-2 bg-white/5 rounded overflow-hidden">
                    <div className="h-full bg-[#FF1493]" style={{ width: `${pct}%` }} />
                  </div>
                  <div className="font-mono-display text-[11px] text-white w-10 text-right">
                    {p.clicks}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default StatsPanel;
